module.exports = __webpack_public_path__ + "img/cart.95c0dad1.png";